export default {
  title: {
    en: 'Act now - get your {discount}% off. Applied Automatically',
  },
  pchTitle: {
    en: '{discount}% off for friends of Publishers Clearing House!',
  },
  dailyBeastTitle: {
    en: 'Act now - get {discount}% off for the daily beast readers. Applied Automatically',
  },
}
